module.exports = __webpack_public_path__ + "img/luxuryyacht_main_04.f486783b.jpg";